import NewsContent from "$lib/data/generated/content/news/data.json";
import ArticlesContent from "$lib/data/generated/content/articles/data.json";

import { uploads as NewsUploads } from "$lib/data/generated/uploads/news/uploads";
import { uploads as ArticlesUploads } from "$lib/data/generated/uploads/articles/uploads";

const content = {
	["news"]: NewsContent,
	["articles"]: ArticlesContent
};
const uploads = {
	...NewsUploads,
	...ArticlesUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (true) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
